<template>
  <crud-form
    v-model="payload"
    :request-class="requestClass"
    page-title="Adicionar integrador"
    :total-group="1"
    navigate-back-route="marca.edit"
    navigate-page-after-save="marca.edit"
    :navigate-back-params="{ id: getIdMarca }"
    :override-create-payload="overrideCreatePayload"
    :override-edit-payload="overrideEditPayload"
    :override-set-entity-data="overrideSetEntityData"
  >
    <template slot="group-1">
      <form-group title="Informações integrador">
        <v-row>
          <v-col cols="6">
            <input-select
              id="input:idIntegrador"
              v-model="payload.idIntegrador"
              :items="codIntegradorOptions"
              :rules="[requiredRule]"
              label="COD Integrador"
              required
            />
          </v-col>
        </v-row>
      </form-group>
    </template>
  </crud-form>
</template>

<script>
import CrudForm from '@/app/arch/components/crud/CrudForm.vue';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import NotificationMixin from '@/app/arch/mixins/NotificationMixin';
import MarcaIntegradorRequest from './MarcaIntegradorRequest';

export default {
  name: 'MarcaIntegradorForm',
  components: { CrudForm, FormGroup },
  mixins: [RulesMixin, NotificationMixin],
  data: () => ({
    requestClass: MarcaIntegradorRequest,
    payload: {
      codIntegrador: '',
      idIntegrador: '',
      idMarca: '',
    },
    codIntegradorOptions: [],
  }),
  computed: {
    getIdMarca() {
      return this.$route.params.marcaId;
    },
    getCodintegrador() {
      return this.codIntegradorOptions.find(
        (item) => item.value === this.payload.idIntegrador,
      ).text;
    },
  },
  beforeMount() {
    this.setIdMarca();
    this.getintegradorList();
  },
  methods: {
    setIdMarca() {
      this.payload.idMarca = this.getIdMarca;
    },
    getintegradorList() {
      this.requestClass.listintegrador()
        .then(({ data }) => {
          this.successintegradorList(data.data);
        }).catch(({ response }) => {
          this.showErrorToast({
            text: response.data.message || 'Falha em busca integrador',
          });
        });
    },
    successintegradorList(data) {
      this.setintegradorList(data);
    },
    setintegradorList(data) {
      this.codIntegradorOptions = data.map((item) => ({
        value: item.id,
        text: item.nomIntegrador,
      }));
    },
    overrideSetEntityData(data) {
      return { ...data };
    },
    overrideCreatePayload() {
      return {
        codIntegrador: this.getCodintegrador,
        idIntegrador: this.payload.idIntegrador,
        idMarca: this.payload.idMarca,
      };
    },
    overrideEditPayload() {
      return { ...this.payload };
    },
  },
};
</script>
